module.exports = __webpack_public_path__ + "static/media/desenhos_diversos.100abf1d.jpg";